var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3335 1C16.8858 1 17.3335 1.44772 17.3335 2V3H19.3335C20.9904 3 22.3335 4.34315 22.3335 6V10V20C22.3335 21.6569 20.9904 23 19.3335 23H5.3335C3.67664 23 2.3335 21.6569 2.3335 20V10V6C2.3335 4.34315 3.67664 3 5.3335 3H7.3335V2C7.3335 1.44772 7.78121 1 8.3335 1C8.88578 1 9.3335 1.44772 9.3335 2V3H15.3335V2C15.3335 1.44772 15.7812 1 16.3335 1ZM7.3335 5V6C7.3335 6.55228 7.78121 7 8.3335 7C8.88578 7 9.3335 6.55228 9.3335 6V5H15.3335V6C15.3335 6.55228 15.7812 7 16.3335 7C16.8858 7 17.3335 6.55228 17.3335 6V5H19.3335C19.8858 5 20.3335 5.44772 20.3335 6V9H4.3335V6C4.3335 5.44772 4.78121 5 5.3335 5H7.3335ZM20.3335 11V20C20.3335 20.5523 19.8858 21 19.3335 21H5.3335C4.78121 21 4.3335 20.5523 4.3335 20V11H20.3335Z",
    fill: "url(#paint0_linear_6873_13135)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6873_13135",
    x1: 10.3897,
    y1: 23,
    x2: 15.058,
    y2: 1.16693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.3321829814625a4aa803a6f80f8cd578.svg";
export { ForwardRef as ReactComponent };